// extracted by mini-css-extract-plugin
module.exports = {"filterListItemCheckbox":"TagsFilter_filterListItemCheckbox__Uc7Yw","filterListItemCheckboxLabel":"TagsFilter_filterListItemCheckboxLabel__wxIk5"};